/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrLineSeriesModule } from './igr-line-series-module';
import { IgrAreaSeriesModule } from './igr-area-series-module';
import { IgrColumnSeriesModule } from './igr-column-series-module';
import { IgrNumericYAxisModule } from './igr-numeric-y-axis-module';
import { IgrTimeXAxisModule } from './igr-time-x-axis-module';
import { IgrTimeAxisBreakModule } from './igr-time-axis-break-module';
import { IgrTimeAxisIntervalModule } from './igr-time-axis-interval-module';
import { IgrTimeAxisLabelFormatModule } from './igr-time-axis-label-format-module';
import { IgrCategoryXAxisModule } from './igr-category-x-axis-module';
import { IgrOrdinalTimeXAxisModule } from './igr-ordinal-time-x-axis-module';
import { IgrPercentChangeYAxisModule } from './igr-percent-change-y-axis-module';
import { IgrFinancialPriceSeriesModule } from './igr-financial-price-series-module';
import { IgrDataChartCategoryTrendLineModule } from './igr-data-chart-category-trend-line-module';
import { IgrIndicatorsModule } from './igr-indicators-module';
import { IgrOverlaysModule } from './igr-overlays-module';
import { IgrZoomSliderModule } from './igr-zoom-slider-module';
import { IgrCrosshairLayerModule } from './igr-crosshair-layer-module';
import { IgrCalloutLayerModule } from './igr-callout-layer-module';
import { IgrItemToolTipLayerModule } from './igr-item-tool-tip-layer-module';
import { IgrCategoryToolTipLayerModule } from './igr-category-tool-tip-layer-module';
import { IgrCategoryHighlightLayerModule } from './igr-category-highlight-layer-module';
import { IgrCategoryItemHighlightLayerModule } from './igr-category-item-highlight-layer-module';
import { IgrDataToolTipLayerModule } from './igr-data-tool-tip-layer-module';
import { IgrFinalValueLayerModule } from './igr-final-value-layer-module';
import { IgrNumberAbbreviatorModule } from './igr-number-abbreviator-module';
import { IgrDataChartInteractivityModule } from './igr-data-chart-interactivity-module';
import { IgrDataChartAnnotationModule } from './igr-data-chart-annotation-module';
import { IgrFinancialLegendModule } from './igr-financial-legend-module';
import { IgrFinancialChartCoreModule } from './igr-financial-chart-core-module';
var IgrFinancialChartModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrFinancialChartModule() {
    }
    IgrFinancialChartModule.register = function () {
        IgrLineSeriesModule.register();
        IgrAreaSeriesModule.register();
        IgrColumnSeriesModule.register();
        IgrNumericYAxisModule.register();
        IgrTimeXAxisModule.register();
        IgrTimeAxisBreakModule.register();
        IgrTimeAxisIntervalModule.register();
        IgrTimeAxisLabelFormatModule.register();
        IgrCategoryXAxisModule.register();
        IgrOrdinalTimeXAxisModule.register();
        IgrPercentChangeYAxisModule.register();
        IgrFinancialPriceSeriesModule.register();
        IgrDataChartCategoryTrendLineModule.register();
        IgrIndicatorsModule.register();
        IgrOverlaysModule.register();
        IgrZoomSliderModule.register();
        IgrCrosshairLayerModule.register();
        IgrCalloutLayerModule.register();
        IgrItemToolTipLayerModule.register();
        IgrCategoryToolTipLayerModule.register();
        IgrCategoryHighlightLayerModule.register();
        IgrCategoryItemHighlightLayerModule.register();
        IgrDataToolTipLayerModule.register();
        IgrFinalValueLayerModule.register();
        IgrNumberAbbreviatorModule.register();
        IgrDataChartInteractivityModule.register();
        IgrDataChartAnnotationModule.register();
        IgrFinancialLegendModule.register();
        IgrFinancialChartCoreModule.register();
    };
    return IgrFinancialChartModule;
}());
export { IgrFinancialChartModule };
